<template>
    <NuxtLink
        to="/resources/design/design-lab"
        class="btn-primary lg:order-2"
        target="_blank"
    >
        Try it now
    </NuxtLink>
</template>
